import { GlobalState } from '../createStore';

export const artworksDomain: any = (state: GlobalState) => state.artworks;
